import { configureStore } from "@reduxjs/toolkit";
import { injectStore } from "../api";
import authSlice from "./slices/auth/slice";
import productsSlice from "./slices/products/slice";
import newsSlice from "./slices/news/slice";
import bandsSlice from "./slices/bands/slice";
import festivalsSlice from "./slices/festivals/slice";
import cartSlice from "./slices/cart/slice";
import ordersSlice from "./slices/orders/slice";
import revenueSlice from "./slices/revenue/slice";
import analyticsSlice from "./slices/analytics/slice";
import reportsSlice from "./slices/reports/slice";
import bandDashboardSlice from "./slices/bandDashboard/slice";
import newslettersSlice from "./slices/newsletters/slice";
import messageSlice from "./slices/message/slice";
import emailVerificationSlice from "./slices/emailVerification/slice";
import viewTrackingSlice from "./slices/viewTracking/slice";
import passwordChangeSlice from "./slices/user/slice";
import supportSlice from "./slices/support/slice";
import bandProductsSlice from "./slices/bandProducts/slice";
import radioSlice from "./slices/radio/slice";

const store = configureStore({
  reducer: {
    authInfo: authSlice,
    productsInfo: productsSlice,
    newsInfo: newsSlice,
    bandsInfo: bandsSlice,
    festivalsInfo: festivalsSlice,
    ordersInfo: ordersSlice,
    revenueInfo: revenueSlice,
    analyticsInfo: analyticsSlice,
    reportsInfo: reportsSlice,
    bandDashboard: bandDashboardSlice,
    newslettersInfo: newslettersSlice,
    messageInfo: messageSlice,
    emailVerification: emailVerificationSlice,
    viewTracking: viewTrackingSlice,
    passwordChange: passwordChangeSlice,
    support: supportSlice,
    cart: cartSlice,
    bandProducts: bandProductsSlice,
    radioInfo: radioSlice,
  },

  devTools: false,
});

injectStore(store);

export default store;
